import { Button, Carousel, MarketIconSymbol, Typography } from "@kyan/ui";
import { useState } from "react";

import { Divider } from "#/components/Divider/Divider";
import { RefCodeInput } from "#/components/RefCodeInput/RefCodeInput";
import { useShowEquityModal } from "#/store/app/equityModal/showEquityModal";
import { useShowWelcomeModal } from "#/store/app/portfolio/showWelcomeModal";
import { PortfolioSymbol } from "#/types/markets";

import { MarginAccountSlide } from "./components/MarginAccountSlide/MarginAccountSlide";
import { OneClickTradingSlide } from "./components/OneClickTradingSlide/OneClickTradingSlide";
import { SlideHeading } from "./components/SlideHeading/SlideHeading";
import { ZeroTradingFeesSlide } from "./components/ZeroTradingFeesSlide/ZeroTradingFeesSlide";

const headings = [
  <SlideHeading key="0" title="Zero Execution Fees" />,
  <SlideHeading
    key="1"
    title="Trade with Portfolio Margin"
    description="Trade BTC and ETH options from a single account"
  />,
  <SlideHeading
    key="2"
    title="One-Click Trading"
    description="Approve once to trade with zero gas fees"
  />,
];
const slides = [
  <ZeroTradingFeesSlide key="0" />,
  <MarginAccountSlide
    key="1"
    height={42}
    width={220}
    icons={[
      {
        name: PortfolioSymbol.BTC.toLowerCase() as MarketIconSymbol,
        text: `${PortfolioSymbol.BTC} Options`,
        iconSize: "sm",
        bgClassName: "size-6",
      },
      {
        name: PortfolioSymbol.USDC.toLowerCase() as MarketIconSymbol,
        text: "Shared Risk",
        iconSize: "xl",
        bgClassName: "size-10",
      },
      {
        name: PortfolioSymbol.ETH.toLowerCase() as MarketIconSymbol,
        text: `${PortfolioSymbol.ETH} Perps`,
        iconSize: "sm",
        bgClassName: "size-6",
      },
    ]}
  />,
  <OneClickTradingSlide key="2" />,
];

export const WelcomeModalContent: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const { setShowWelcomeModal } = useShowWelcomeModal();
  const { setShowEquityModal } = useShowEquityModal();

  const handleDepositFunds = () => {
    setShowEquityModal(true);
    setShowWelcomeModal(false);
  };

  const handleSlideChange = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <div className="flex flex-col gap-5">
      <Typography element="h2" font="grotesk" weight="medium" variant="primary">
        Welcome to Kyan Beta
      </Typography>
      <Typography element="p" className="pr-4">
        Deposit equity to begin trading options, perps, and multi-leg strategies
        with portfolio margin.
      </Typography>
      <Typography element="p" className="pr-4">
        If you&apos;ve got{" "}
        <Typography primary>a referral code, enter it down below</Typography>{" "}
        and deposit funds.
      </Typography>

      <div className="flex flex-col gap-4">
        <div className="dark:bg-buttonFill border-divider flex flex-col rounded-sm border dark:border-transparent">
          <Carousel showControls={false} value={currentSlide}>
            {headings}
          </Carousel>

          <Divider />

          <Carousel
            showControls
            value={currentSlide}
            className="w-92 self-center pt-3 pb-4"
            onChange={handleSlideChange}
          >
            {slides}
          </Carousel>
        </div>
        <RefCodeInput variant="inline" />
        <Button size="xl" className="w-full" onClick={handleDepositFunds}>
          Deposit funds
        </Button>
      </div>
    </div>
  );
};
